// ===== WorkReviewCount: 상단 네비 "업무" 그룹 미처리 카운트 배지 (Phase 2, CAP07/08/09/10) =====
// 카운트 소스(CAP09): GET /api/work/outbox?lifecycle=active 건수(pending_review).
// 옛 제안 검토(검토 문서) 흐름은 한 번 확인 등록(records-ssot F5)으로 대체되어 진입 메뉴가 없으므로
// 제안 건수는 세지 않는다 — 열 수 없는 항목을 배지가 세지 않게 한다.
//
// 갱신 채널(D04): ws-handlers.ts가 위임하는 work-badge-refresh(콘텐츠 없는 팀-글로벌 신호) 수신 시
// 재조회 + router.ts navigate()가 발행하는 view-navigated 이벤트 수신 시 재조회(진입 시 서버 진실
// 보정) + 앱 부트 시 1회 초기 재조회(work-badge.ts 부트 관용 미러).
//
// 렌더: 그룹 토글(.top-nav-group[data-group-id="work"] .top-nav-group-toggle)과 "업무" 항목(work)에는 업무 화면
// "확인할 것"과 같은 수(보는 사람이 응답할 것 = 나에게 온 후보 + 내가 응답할 프로젝트 요청, 라운드 3 검토 반영)를,
// "업무 후보함" 항목(work-outbox)에는 그 화면 목록과 같은 팀 전체 미처리 후보 수를 단다. 0건이면 숨긴다(CAP10).
// 후보 선별 규칙은 views/work/board.ts _boardFilterCandidatesForViewer 하나를 같이 쓴다(제안된 담당이 나이거나 담당 없음).

var WorkReviewCount = (function () {
  var _outboxCount = 0;
  var _attentionCount = 0;

  function _isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === "object" && value !== null && !Array.isArray(value);
  }

  async function _fetchList(url: string, listKey: string): Promise<unknown[]> {
    var response = await fetch(url);
    var payload: unknown = await response.json().catch(function () { return {}; });
    if (!response.ok || (_isRecord(payload) && payload.ok === false)) {
      throw new Error("Request failed: " + response.status);
    }
    var list = _isRecord(payload) ? payload[listKey] : undefined;
    return Array.isArray(list) ? list : [];
  }

  /** 내가 응답할 프로젝트 요청 수(운영표 viewer.pending, 업무 화면 projects.ts workProjectsAttentionCount 와 같은 규칙). 없거나 실패하면 0. */
  async function _projectRequestCount(): Promise<number> {
    try {
      var sheets = await _fetchList("/api/company/projects/sheets", "projects");
      return sheets.filter(function (sheet) {
        return _isRecord(sheet) && _isRecord(sheet.viewer) && typeof sheet.viewer.pending === "string" && sheet.viewer.pending !== "" && !sheet.invalid;
      }).length;
    } catch (error) {
      return 0;
    }
  }

  // ===== 배지 DOM 주입/갱신 =====

  function _applyBadge(host: Element | null, className: string, count: number, beforeEl: Element | null): void {
    if (!host) return;
    var badge = host.querySelector<HTMLElement>("." + className);
    if (!badge) {
      badge = document.createElement("span");
      badge.className = "work-review-count-badge " + className;
      if (beforeEl) host.insertBefore(badge, beforeEl);
      else host.appendChild(badge);
    }
    if (count <= 0) {
      badge.style.display = "none";
      badge.textContent = "";
      return;
    }
    badge.textContent = String(count);
    badge.style.display = "";
  }

  function _renderGroupBadge(): void {
    var toggle = document.querySelector<HTMLElement>('.top-nav-group[data-group-id="work"] .top-nav-group-toggle');
    if (!toggle) return;
    _applyBadge(toggle, "work-review-count-badge--group", _attentionCount, toggle.querySelector(".top-nav-chevron"));
  }

  function _renderItemBadge(viewId: string, count: number): void {
    var item = document.querySelector<HTMLElement>('.top-nav-dropdown-item[data-view="' + viewId + '"]');
    _applyBadge(item, "work-review-count-badge--item", count, null);
  }

  function _render(): void {
    _renderGroupBadge();
    _renderItemBadge("work", _attentionCount);
    _renderItemBadge("work-outbox", _outboxCount);
  }

  // ===== 서버 진실 기반 재조회 =====

  // 재조회는 로그인 확인(BigtionAuth.ready) 뒤에 한다: "확인할 것" 정의는 보는 사람을 알아야 하고(확인 전에는 viewerActorId 가
  // 비어 남의 후보까지 센다), 부트 직후 요청을 늘려 ws 연결(같은 ready 뒤에 먼저 걸린다)보다 앞서지 않게 한다.
  function _authReady(): Promise<unknown> {
    var auth = typeof window !== "undefined" ? window.BigtionAuth : undefined;
    if (!auth || !auth.ready || typeof auth.ready.then !== "function") return Promise.resolve();
    return auth.ready.catch(function () { return undefined; });
  }

  async function refresh(): Promise<void> {
    await _authReady();
    try {
      var results = await Promise.all([_fetchList("/api/work/outbox?lifecycle=active", "items"), _projectRequestCount()]);
      var items = results[0];
      var viewer = typeof viewerActorId === "function" ? viewerActorId() : null;
      var mine = typeof _boardFilterCandidatesForViewer === "function" ? _boardFilterCandidatesForViewer(items, viewer).length : items.length;
      _outboxCount = items.length;
      _attentionCount = mine + results[1];
    } catch (error) {
      console.error("[work-review-count] refresh 실패:", error instanceof Error ? error.message : String(error));
      _outboxCount = 0;
      _attentionCount = 0;
    }
    _render();
  }

  // ===== ws 이벤트 위임 대상 (ws-handlers.js가 호출) =====
  // work-badge-refresh는 콘텐츠 없는 팀-글로벌 신호라 게이트 없이 항상 재조회한다.
  function onWorkBadgeRefresh(_data?: unknown): void {
    void refresh();
  }

  return {
    refresh: refresh,
    onWorkBadgeRefresh: onWorkBadgeRefresh,
  };
})();

document.addEventListener("DOMContentLoaded", function () {
  void WorkReviewCount.refresh();
});

// router.ts navigate()가 발행하는 뷰 전환 신호 — 진입 시 서버 진실 재조회 보정(D04).
document.addEventListener("view-navigated", function () {
  void WorkReviewCount.refresh();
});
